import { render, staticRenderFns } from "./openOrder.vue?vue&type=template&id=a76048aa&scoped=true"
import script from "./openOrder.vue?vue&type=script&lang=js"
export * from "./openOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76048aa",
  null
  
)

export default component.exports